<template>
  <overlay
    key="private-collection"
    block-class="private-collection"
    direction="void"
    namespace="CollectionLock"
    type="modal"
    :template="false"
  >
    <template #body>
      <p
        class="private-collection__title text-center text-desktop-18-uc"
        v-text="$string('collection.locked.title')"
      />
      <p
        class="private-collection__message text-desktop-regular"
        v-text="$string('collection.locked.message')"
      />
      <button
        type="button"
        class="button button--block private-collection__cta"
        @click.prevent="handleLoginRedirect"
        v-text="$string('collection.locked.cta')"
      />
      <button
        type="button"
        class="private-collection__close"
        @click.prevent="lockDismissed"
        v-text="$string('collection.locked.close')"
      />
    </template>
  </overlay>
</template>

<script>
import Overlay from '~global/overlay/overlay.vue'
import { mapActions } from 'vuex'

export default {
  name: 'PrivateCollection',

  components: {
    Overlay,
  },

  emits: {
    dismissed: (payload) => payload,
  },

  mounted() {
    this.showCollectionLock()
  },

  methods: {
    ...mapActions({
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
      stickOverlay: 'overlays/setStuck',
    }),

    showCollectionLock() {
      this.openOverlay({
        callback: this.lockDismissed,
        namespace: 'CollectionLock',
        ignoreDismissed: true,
        stuck: true,
      })
    },

    handleLoginRedirect() {
      try {
        window.localStorage.setItem('locked_collection_redirect', window.location.href)
        window.location.assign(this.$variable('routes.account.login'))
      } catch (err) {
        // Something went wrong, reload the page and try again
        window.location.reload()
      }
    },

    lockDismissed() {
      this.$emit('dismissed')
      this.stickOverlay('CollectionLock', false)
      this.closeOverlay('CollectionLock')
      window.location.assign(this.$variable('routes.root'))
    },
  },
}
</script>

<style lang="scss">
  @import "./private-collection";
</style>
